import { Header } from './Header';
import { Footer } from './Footer';
import { ProtectedRoute } from './ProtectedRoute';
import styles from './AuthenticatedLayout.module.css';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

export function AuthenticatedLayout({ children }: AuthenticatedLayoutProps) {
  return (
    <ProtectedRoute>
      <div className={styles.layout}>
        <Header />
        <main className={styles.main}>
          <div className={styles.container}>
            {children}
          </div>
        </main>
        <Footer />
      </div>
    </ProtectedRoute>
  );
}
